import { Separator } from "@arcadeai/design-system/components/ui/atoms/separator";
import { useParams } from "@tanstack/react-router";
import { columns } from "@/app/tools/data-table/columns";
import { ToolsTable } from "@/app/tools/data-table/tools-table";
import type { Tool } from "@/app/tools/types";

export const SecretDetails = () => {
  const { secretId } = useParams({
    from: "/_authenticated/orgs/$organizationId/projects/$projectId/auth/secrets/$secretId",
  });

  const filteredTools: Tool[] = [];

  return (
    <div className="flex flex-col gap-4">
      <div className="flex flex-col items-start justify-between gap-6 md:flex-row md:items-end">
        <div className="flex flex-col gap-2">
          <h1 className="-mb-4 font-bold text-2xl">Tools</h1>
          <div className="flex items-center justify-between">
            <p className="text-muted-foreground text-sm">
              Tools available in {secretId}
            </p>
          </div>
        </div>
      </div>
      <Separator className="mb-4" />
      <ToolsTable columns={columns} data={filteredTools} />
    </div>
  );
};
